import { render, staticRenderFns } from "./docReadStatus.vue?vue&type=template&id=1a122f17&scoped=true"
import script from "./docReadStatus.vue?vue&type=script&lang=js"
export * from "./docReadStatus.vue?vue&type=script&lang=js"
import style0 from "./docReadStatus.vue?vue&type=style&index=0&id=1a122f17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a122f17",
  null
  
)

export default component.exports